<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 106.166 52.917"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      class="triangle"
      d="m11.947 52.917 7.52-12.283 7.52 12.283Z"
    />
    <path
      class="globe"
      d="M28.229 23.417c.298-1.504.485-3.092.554-4.726h5.091a14.367 14.367 0 0 1-1.286 4.726Zm1.474 4.105a14.488 14.488 0 0 1-4.053 2.861c.24-.388.47-.801.688-1.239.45-.897.841-1.875 1.173-2.917h3.342c-.355.45-.739.883-1.15 1.295m-8.83-4.105V18.69h5.097a27.764 27.764 0 0 1-.61 4.726Zm2.952 4.47c-.857 1.714-1.887 2.919-2.953 3.493v-5.153h3.67a16.722 16.722 0 0 1-.717 1.66m-8.716 0c-.26-.521-.5-1.076-.716-1.66h3.669v5.153c-1.066-.574-2.096-1.779-2.953-3.493m-2.145-9.196h5.098v4.726h-4.488a27.764 27.764 0 0 1-.61-4.726m-3.733 8.831a14.704 14.704 0 0 1-1.15-1.295h3.342c.332 1.042.724 2.02 1.172 2.917.22.438.449.851.689 1.24a14.48 14.48 0 0 1-4.053-2.862m-2.885-4.105a14.363 14.363 0 0 1-1.287-4.726h5.092c.069 1.634.256 3.222.554 4.726zm4.359-12.262a31.079 31.079 0 0 0-.554 4.726H5.06a14.363 14.363 0 0 1 1.287-4.726zM9.231 7.05a14.485 14.485 0 0 1 4.052-2.86c-.24.387-.469.8-.688 1.238-.448.898-.84 1.876-1.172 2.917H8.08c.355-.45.738-.883 1.15-1.295m8.83 4.105v4.726h-5.097c.075-1.652.281-3.244.61-4.726zm-2.952-4.47c.857-1.714 1.887-2.918 2.953-3.493v5.153h-3.67c.217-.583.456-1.138.717-1.66m8.716 0c.26.522.5 1.077.716 1.66h-3.669V3.192c1.066.575 2.096 1.78 2.953 3.493m2.145 9.196h-5.098v-4.726h4.488c.328 1.482.535 3.074.61 4.726m3.733-8.83c.411.411.795.844 1.15 1.294h-3.342a20.314 20.314 0 0 0-1.173-2.917 15.822 15.822 0 0 0-.688-1.239 14.49 14.49 0 0 1 4.053 2.861m2.885 4.105a14.367 14.367 0 0 1 1.286 4.726h-5.091a31.079 31.079 0 0 0-.554-4.726Zm-.898-6.092A17.173 17.173 0 0 0 19.467 0 17.173 17.173 0 0 0 7.244 5.063 17.174 17.174 0 0 0 2.18 17.286c0 4.618 1.798 8.959 5.063 12.223a17.173 17.173 0 0 0 12.223 5.064c4.617 0 8.958-1.799 12.223-5.064a17.173 17.173 0 0 0 5.063-12.223c0-4.617-1.798-8.958-5.063-12.223"
    />
    <path
      class="plate"
      d="M0 36.198h38.934v2.81H0Z"
    />
    <g class="main-text">
      <path d="M48.51 7.923h7.164v37.07H48.51z" />
      <path
        d="M60.788 42.793c-1.626-1.698-2.439-4.028-2.439-6.991v-17.09c0-3.683.734-6.459 2.201-8.33 1.468-1.87 3.769-2.804 6.905-2.804 2.733 0 4.934.748 6.603 2.244 1.668 1.496 2.503 3.654 2.503 6.473v6.387h-7.38v-5.48c0-1.065-.129-1.799-.388-2.202-.259-.402-.705-.604-1.338-.604-.662 0-1.115.23-1.36.69-.244.461-.366 1.137-.366 2.029v18.6c0 .979.144 1.69.431 2.136.288.447.72.67 1.295.67 1.15 0 1.726-.935 1.726-2.806v-6.689h7.466v6.991c0 6.215-3.122 9.322-9.365 9.322-2.704 0-4.87-.848-6.494-2.546"
      />
      <path d="M78.762 7.923h7.164v37.07h-7.164z" />
      <path
        d="M92.528 44.346a7.609 7.609 0 0 1-3.258-2.913c-.792-1.28-1.187-2.826-1.187-4.639V29.03h7.294v7.333c0 .662.136 1.186.41 1.575.273.388.697.582 1.273.582.546 0 .956-.18 1.23-.539.273-.36.41-.87.41-1.532V7.923h7.466v27.792c0 1.928-.382 3.619-1.144 5.071-.763 1.453-1.827 2.575-3.194 3.366-1.366.792-2.927 1.187-4.682 1.187-1.698 0-3.237-.331-4.618-.993"
      />
    </g>
  </svg>
</template>

<script setup lang="ts">
defineOptions({
  name: 'BrandExpansionShort'
})

defineProps<{
  width?: string
  height?: string
}>()
</script>
